import { useQuery, UseQueryOptions } from 'react-query';
import i18next from 'i18next';
import message from '../components/Message';
import { getUser } from '../APIs';
import {
  authErrorCode,
  getUserId, getUserSlug, getUserToken, isLogOutStatus, removeCreds,
} from '../APIs/utils';

/**
 *
 * @param {UseQueryOptions} options
 */
function useAutoSignIn(options) {
  const userId = getUserId();
  const userToken = getUserToken();
  const userSlug = getUserSlug();

  const shouldTry = !!(userId && userToken && userSlug);
  return useQuery('currentUser', () => getUser().catch((error) => {
    if (isLogOutStatus(error?.statusCode)) {
      removeCreds(false);
      message.error(i18next.t(authErrorCode));
      return null;
    }
    return Promise.reject(error);
  }), {
    enabled: shouldTry,
    ...options,
  });
}
export default useAutoSignIn;
